import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    counter: {
        height: '28px',
        borderRadius: '4px',
        backgroundColor: '#E0E0E0',
        display: 'inline-block',
        '& span': {
            padding: '10px'
        }
    },
    addButton: {
        borderRadius: '4px 0 0 4px',
        backgroundColor: '#272727',
        width: '22px',
        padding: '2px',
        color: 'white',
    },
    subtractButton: {
        borderRadius: '0 4px 4px 0',
        backgroundColor: '#272727',
        width: '22px',
        padding: '2px',
        color: 'white',
    }
}));

export default function CustomCounter({ value, handleAdd, handleSubtract }) {
    const classes = useStyles();
    return (
        <div className={classes.counter}>
            <button className={classes.addButton} onClick={handleSubtract}>-</button>
            <span>{value}</span>
            <button className={classes.subtractButton} onClick={handleAdd}>+</button>
        </div>
    );
}
